module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/403.008a35b2.png";